import * as Highcharts from 'highcharts';
import * as HighchartsBorderRadius from 'highcharts-rounded-corners';
import * as jQuery from 'jquery';
import * as moment from 'moment';
import * as _ from 'underscore';

import {
	AfterContentChecked,
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild
} from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { GraphDataModel } from '../daily-stats/daily-stats.component';

HighchartsBorderRadius(Highcharts);

@Component({
	selector: 'app-dailymetrics-r5',
	styleUrls: ['./dailymetrics-r5.component.css'],
	templateUrl: './dailymetrics-r5.component.html'
})
export class DailymetricsR5Component implements OnInit, WidgetCore, AfterContentChecked {
	@ViewChild('graphArea', { static: true }) graphElement: ElementRef;

	@Input() barchartconfiguration;
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() colors: string;
	@Input() colorsconfig: any;
	@Input() downloadconfig: string;
	@Input() legend: any;
	@Input() legendDisabled;
	@Input() sectionclass: any;
	@Input() svgHeight;
	@Input() ticksRotation;
	@Input() downloadcsvcolumns: any;
	@Input() iscustomendpoint: any;
	public colorPalette: ColorPalette;
	public showLoad = false;
	public hasData: boolean;
	public graphData = {};
	public downloadConfiguration: DownloadConfig;
	public selectedMetrics: any;
	public reloadSubscription;
	public secondaryColor = '#d8d8d8';
	public bgColor: any;
	public oppColor: any;
	public dateArray: any;
	public selectedLegend: any;
	public dateRange: string;
	public chartObj: any;
	public responseObject: any;
	public filteredLegends: any = [];
	public screenWidth: any;
	public partner: string;
	public leftArrowPosition: any = '2%';
	public rightArrowPosition: any = '98%';
	public barChartDataConfiguration: any;
	public tickLength: number = 1;
	public downloadCSVColumns: any;
	public newTabXLSXRequired: boolean = false;
	public isR9: boolean = false;

	// tslint:disable-next-line: prefer-output-readonly
	@Output() emitData: EventEmitter<any> = new EventEmitter<any>();
	// tslint:disable-next-line: prefer-output-readonly
	@Output() legendSelected = new EventEmitter<any>();

	protected graphObj: GraphDataModel = {} as GraphDataModel;

	private dataLength = 0;
	private leftExtreme = 0;
	private rightExtreme = 0;
	private stepCount = 87;
	private pointsCount = 8;
	public currentPageClass: string;

	constructor(
		private analyticsService: AnalyticsService,
		private colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.screenWidth = window.innerWidth;
			this.findArrowPosition();
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.isR9 = this.analyticsDataModel.config.version === 'R9' ? true : false;
		this.barChartDataConfiguration = JSON.parse(decodeURI(this.barchartconfiguration));
		this.partner = this.analyticsDataModel.partner.analyticsConfig;
		this.legend = JSON.parse(decodeURI(this.legend));
		this.legend = _.filter(this.legend, (item) => {
			return this.analyticsDataModel.checkComponentForPermission(item);
		});
		this.colorsconfig = JSON.parse(decodeURI(this.colorsconfig));
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.filteredLegends = JSON.parse(JSON.stringify(this.legend));
		if (
			this.downloadConfiguration &&
			this.downloadConfiguration.permission &&
			this.downloadConfiguration?.permission['flags']
		) {
			this.newTabXLSXRequired = !this.downloadConfiguration.permission['flags']
				.map((permission) => {
					return this.analyticsDataModel
						.checkComponentForPermission({ permission: { flags: [permission] } })
						.toString();
				})
				.includes('false');
		}
		this.findArrowPosition();
		this.processLegendData();
		this.currentPageClass = this.analyticsDataModel.getCurrentPath() + '_PAGE_SPECIFIC';
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (!_.isEmpty(this.graphData)) {
			this.dataLength = this.graphData['categories'].length - 1;
			this.drawGraph();
		}
	}

	ngAfterContentChecked(): void {
		jQuery('.legend_item').css({ color: '#2e2e2e' });
		jQuery('.item_selected').css({ color: this.colorPalette.primaryColor });
	}

	findArrowPosition(): void {
		if (this.partner.indexOf('r11') !== -1) {
			this.tickLength = 0;
			if (this.screenWidth > 1200 && this.screenWidth <= 1400) {
				this.leftArrowPosition = '2.5%';
				this.rightArrowPosition = '95%';
			} else if (this.screenWidth > 1400 && this.screenWidth <= 1850) {
				this.leftArrowPosition = '2%';
				this.rightArrowPosition = '96%';
			} else if (this.screenWidth > 1850 && this.screenWidth <= 2300) {
				this.leftArrowPosition = '1.5%';
				this.rightArrowPosition = '97%';
			} else if (this.screenWidth >= 2300) {
				this.leftArrowPosition = '1.3%';
				this.rightArrowPosition = '98%';
			}
		} else if (this.partner.indexOf('r11') === -1) {
			this.leftArrowPosition = '2.5%';
			this.rightArrowPosition = '98%';
		}
	}

	@HostListener('window:resize', ['$event'])
	onResize(event: any): void {
		this.screenWidth = window.innerWidth;
		this.findArrowPosition();
		this.drawGraph();
	}

	requestData(): void {
		this.showLoad = true;
		this.hasData = true;
		this.filterLegends();
		if (this.iscustomendpoint == 'true') {
			this.analyticsService.processCustomServiceRequest(this.key).subscribe((response: any) => {
				this.showLoad = false;
				if (response.success && response.data.length > 0) {
					const sortedData = _.sortBy(response.data, 'date');
					const metricsData = _.pluck(sortedData, 'aired_spots');
					const emptyAiredSpots = metricsData.every((item) => {
						return item == null;
					});
					if (emptyAiredSpots && this.sectionclass === 'ovw_daily_mtrcs') {
						for (const legendObj of this.legend) {
							legendObj['selected'] = false;
						}
						this.selectedMetrics = this.legend[1].value;
						this.legend[1].selected = true;
						this.selectedLegend = this.legend[1];
					} else {
						for (const legendObj of this.legend) {
							legendObj['selected'] = false;
						}
						this.selectedMetrics = this.legend[0].value;
						this.legend[0].selected = true;
						this.selectedLegend = this.legend[0];
					}
					this.responseObject = response.data;
					this.hasData = true;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
				}
			});
		} else {
			this.analyticsService.processWidgetRequest(this.key).subscribe((response: any) => {
				this.showLoad = false;
				if (response.success && response.data.length > 0) {
					const sortedData = _.sortBy(response.data, 'date');
					const metricsData = _.pluck(sortedData, 'aired_spots');
					const emptyAiredSpots = metricsData.every((item) => {
						return item == null;
					});
					if (emptyAiredSpots && this.sectionclass === 'ovw_daily_mtrcs') {
						for (const legendObj of this.legend) {
							legendObj['selected'] = false;
						}
						this.selectedMetrics = this.legend[1].value;
						this.legend[1].selected = true;
						this.selectedLegend = this.legend[1];
					} else {
						for (const legendObj of this.legend) {
							legendObj['selected'] = false;
						}
						this.selectedMetrics = this.legend[0].value;
						this.legend[0].selected = true;
						this.selectedLegend = this.legend[0];
					}
					this.responseObject = response.data;
					this.hasData = true;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
				}
			});
		}
	}

	processResponseData(response: any): void {
		const sortedData = _.sortBy(response, 'date');
		this.dateArray = _.pluck(sortedData, 'date');
		this.graphData['categories'] = _.pluck(sortedData, 'date');
		this.graphData['series'] = [];
		const metricsData = _.pluck(sortedData, this.selectedMetrics);
		this.generateColumGraphData(this.graphData, metricsData);
		this.graphData['backgroundColor'] = '#fff';
	}

	generateColumGraphData(graphData: any, metricsData: any): void {
		const categories = [];
		const data = [];
		const seriesObj = {};
		const newMetrics = [];
		for (let i = 0; i < graphData.categories.length; i++) {
			if (moment(graphData.categories[i], 'YYYY-MM-DD').weekday() === 1) {
				categories.push(-1);
				newMetrics.push(null);
				newMetrics.push(metricsData[i]);
				categories.push({
					date: this.dateArray[i],
					value: 'M'
				});
			} else {
				categories.push({
					date: this.dateArray[i],
					value: this.isR9 ? Array.from(moment(graphData.categories[i], 'YYYY-MM-DD HH:mm:ss').format('ddd'))[0] : ''
				});
				newMetrics.push(metricsData[i]);
			}
		}
		for (let i = 0; i < newMetrics.length; i++) {
			const obj = {};
			if (categories[i].value === 'M') {
				obj['y'] = Number(newMetrics[i]);
				obj['color'] = this.colorPalette.primaryColor;
			} else {
				obj['y'] = Number(newMetrics[i]);
				obj['color'] = this.colorPalette.quaternaryColor;
				if (this.partner.indexOf('default-r1102') !== -1) {
					obj['color'] = this.colorUtilityService.getRGBByOpacity(this.colorPalette.primaryColor, 0.15);
				} else if (this.partner.indexOf('r11') !== -1) {
					obj['color'] = this.colorUtilityService.getRGBByOpacity(this.colorPalette.secondaryColor, 0.5);
				} else if (this.partner.indexOf('r9') !== -1) {
					obj['color'] = this.colorPalette.primaryColor;
				}
			}
			data.push(obj);
		}
		seriesObj['name'] = this.selectedMetrics;
		seriesObj['data'] = data;
		this.graphData['series'].push(seriesObj);
		const plotLinesObj = this.generatePlotLines(categories);
		this.graphData['categories'] = plotLinesObj.categories;
		this.graphData['plotLines'] = plotLinesObj.plotLines;
		this.graphData['plotOptions'] = {
			series: {
				borderRadius: 4,
				pointWidth: 5
			}
		};
		this.dataLength = this.graphData['categories'].length - 1;
		this.drawGraph();
	}

	generatePlotLines(categories: any[]): any {
		const plotLines = [];
		const lineObj = {
			color: this.secondaryColor,
			dashStyle: 'ShortDash',
			label: {
				enabled: false
			},
			value: 0,
			width: 1
		};
		// tslint:disable-next-line: no-parameter-reassignment
		categories = categories.map((val, index) => {
			if (val === -1) {
				lineObj.value = index;
				plotLines.push(JSON.parse(JSON.stringify(lineObj)));
				return {
					value: ''
				};
			} else {
				return val;
			}
		});
		return { categories, plotLines };
	}

	filterLegends(): void {
		const dateSet = {
			depricatedDate: this.analyticsDataModel.depricatedDate,
			endDate: this.analyticsDataModel.endDate,
			goLiveDate: this.analyticsDataModel.goLiveDate,
			startDate: this.analyticsDataModel.startDate
		};
		this.filteredLegends = this.checkForVisibilityPermissions(this.legend, dateSet);
	}

	checkForVisibilityPermissions(columns: any, dateSet: any): any {
		const { startDate, endDate, depricatedDate, goLiveDate } = dateSet;
		const isGoliveNotStarted = moment(endDate).isBefore(goLiveDate);
		const isCutoffDate = moment(startDate).isAfter(depricatedDate) || moment(startDate).isSame(depricatedDate);
		const avgPositionFilterText = ['avg_position', 'avgPosition', 'Avg. Position'];
		const newImpressionsFilterText = ['abs_top_impression_share', 'top_impression_share'];

		if (isGoliveNotStarted) {
			// tslint:disable-next-line: no-parameter-reassignment
			columns = columns.filter((item) => !newImpressionsFilterText.includes(item.value));
		}
		if (isCutoffDate) {
			// tslint:disable-next-line: no-parameter-reassignment
			columns = columns.filter((item) => !avgPositionFilterText.includes(item.value));
		}
		return columns;
	}

	processSelectedLegendItem(legendItem: any): void {
		for (const legendObj of this.filteredLegends) {
			legendObj.selected = false;
		}
		this.selectedLegend = _.findWhere(this.filteredLegends, { value: legendItem.value });
		this.selectedLegend.selected = true;
		this.selectedMetrics = legendItem.value;
		this.requestData();
	}
	drawGraph(): void {
		this.findArrowPosition();
		this.bgColor = '#fff';
		this.oppColor = '#2e2e2e';
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		this.dataLength = this.graphData['categories'].length - 1;
		const dateFormat =
			'tooltip' in this.barChartDataConfiguration ? this.barChartDataConfiguration.tooltip.dateFormat : 'M/DD/YYYY';
		this.chartObj = Highcharts.chart(
			this.graphElement.nativeElement,
			{
				chart: {
					backgroundColor: this.bgColor,
					height: 'svgHeight' in this.barChartDataConfiguration ? this.barChartDataConfiguration.svgHeight : 250,
					marginLeft: 55,
					marginRight:
						'marginRight' in this.barChartDataConfiguration ? this.barChartDataConfiguration.marginRight : 50,
					type: 'column'
				},
				credits: {
					enabled: false
				},
				legend: {
					enabled: false
				},
				plotOptions: {
					column: {
						borderWidth: 0,
						pointWidth: 5
					}
				},
				series: this.updateBorders(this.graphData['series']),
				title: {
					text: null
				},
				tooltip: {
					backgroundColor:
						'tooltip' in this.barChartDataConfiguration
							? this.barChartDataConfiguration.tooltip.backgroundColor
							: '#fff',
					borderColor: this.secondaryColor,
					borderRadius:
						'tooltip' in this.barChartDataConfiguration ? this.barChartDataConfiguration.tooltip.borderRadius : 5,
					useHTML: true,
					formatter(): string {
						return (
							// tslint:disable-next-line: prefer-template
							'<div style="text-align:center; padding: 2px">' +
							self.updateTooltipName() +
							'<br/><b>' +
							this.y.toLocaleString() +
							(this.series.name === 'CTR' ? '%' : '') +
							'</b><br/>' +
							moment(this.x['date'], 'YYYY-MM-DD').format(dateFormat) +
							'</div>'
						);
					}
				},
				xAxis: {
					categories: this.graphData['categories'],
					gridLineColor: this.bgColor,
					labels: {
						step: 1,
						style: {
							color: '#000',
							fontSize:
								'xAxisConfig' in this.barChartDataConfiguration &&
								'labels' in this.barChartDataConfiguration.xAxisConfig
									? this.barChartDataConfiguration.xAxisConfig.labels.fontSize
									: 11
						},
						y: 'y' in this.barChartDataConfiguration ? this.barChartDataConfiguration.y : 25,
						formatter(): any {
							return this.value['value'];
						}
					},
					lineColor: this.bgColor,
					lineWidth: 0,
					minorGridLineWidth: 0,
					minorTickLength: 1,
					offset: 5,
					plotLines: this.graphData['plotLines'],
					tickLength: this.tickLength ? this.tickLength : 1
				},
				yAxis: {
					gridLineColor: this.bgColor,
					labels: {
						align: 'left',
						enabled: true,
						style: {
							fontSize:
								'xAxisConfig' in this.barChartDataConfiguration &&
								'labels' in this.barChartDataConfiguration.xAxisConfig
									? this.barChartDataConfiguration.xAxisConfig.labels.fontSize
									: 11
						},
						x: -50,
						formatter(): string {
							if (this.value > 999) {
								return `${(Number(this.value) / 1000).toFixed(1)}k`;
							}
							return String(this.value);
						}
					},
					lineColor: this.bgColor,
					stackLabels: {
						enabled: false,
						style: {
							color: 'gray',
							fontWeight: 'bold'
						}
					},
					title: {
						text: null
					},
					tickPositioner(): any[] {
						return [0, Math.ceil(this.max / 2), Math.ceil(this.max)];
					}
				}
			},
			(chart: any) => {
				// on complete
				function noop(): void {}
				if (this.dataLength > this.stepCount) {
					this.leftExtreme = 0;
					this.rightExtreme = this.stepCount;
					chart['left'] = chart.renderer
						.image('../../../../../assets/images/left_arrow.png', 0, 0, 9, 14)
						.on('click', () => {
							if (this.leftExtreme > this.pointsCount) {
								this.leftExtreme -= this.pointsCount;
								this.rightExtreme -= this.pointsCount;
								chart['left'].show();
								chart['right'].show();
							} else {
								this.leftExtreme = 0;
								this.rightExtreme = this.stepCount;
								chart['left'].hide();
								chart['right'].show();
							}
							// tslint:disable-next-line: no-shadowed-variable
							let startDate = '';
							// tslint:disable-next-line: no-shadowed-variable
							let endDate = '';
							if (
								moment(self.graphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
								'Invalid date'
							) {
								startDate = moment(self.graphData['categories'][this.leftExtreme + 1].date, 'YYYY-MM-DD').format(
									'M/D/YY'
								);
							} else {
								startDate = moment(self.graphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('M/D/YY');
							}
							if (
								moment(self.graphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
								'Invalid date'
							) {
								endDate = moment(self.graphData['categories'][this.rightExtreme - 1].date, 'YYYY-MM-DD').format(
									'M/D/YY'
								);
							} else {
								endDate = moment(self.graphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('M/D/YY');
							}
							this.dateRange = `${startDate} - ${endDate}`;
							chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
							chart.redraw();
						})
						.css({ cursor: 'pointer' })
						.attr('x', this.leftArrowPosition)
						.attr('y', '41%')
						.add();
					chart['right'] = chart.renderer
						.image('../../../../../assets/images/right_arrow.png', 0, 0, 9, 14)
						.on('click', () => {
							if (this.dataLength - this.rightExtreme > this.pointsCount) {
								this.leftExtreme += this.pointsCount;
								this.rightExtreme += this.pointsCount;
								chart['left'].show();
								chart['right'].show();
							} else {
								this.leftExtreme = this.dataLength - this.stepCount;
								this.rightExtreme = this.dataLength;
								chart['left'].show();
								chart['right'].hide();
							}
							// tslint:disable-next-line: no-shadowed-variable
							let startDate = '';
							// tslint:disable-next-line: no-shadowed-variable
							let endDate = '';
							if (
								moment(self.graphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
								'Invalid date'
							) {
								startDate = moment(self.graphData['categories'][this.leftExtreme + 1].date, 'YYYY-MM-DD').format(
									'M/D/YY'
								);
							} else {
								startDate = moment(self.graphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('M/D/YY');
							}
							if (
								moment(self.graphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
								'Invalid date'
							) {
								endDate = moment(self.graphData['categories'][this.rightExtreme - 1].date, 'YYYY-MM-DD').format(
									'M/D/YY'
								);
							} else {
								endDate = moment(self.graphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('M/D/YY');
							}
							this.dateRange = `${startDate} - ${endDate}`;
							chart.xAxis[0].setExtremes(this.leftExtreme, this.rightExtreme);
							chart.redraw();
						})
						.css({ cursor: 'pointer' })
						.attr('x', this.rightArrowPosition)
						.attr('y', '41%')
						.add();
					let startDate = '';
					let endDate = '';
					if (
						moment(self.graphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
						'Invalid date'
					) {
						startDate = moment(self.graphData['categories'][this.leftExtreme + 1].date, 'YYYY-MM-DD').format('M/D/YY');
					} else {
						startDate = moment(self.graphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('M/D/YY');
					}
					if (
						moment(self.graphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
						'Invalid date'
					) {
						endDate = moment(self.graphData['categories'][this.rightExtreme - 1].date, 'YYYY-MM-DD').format('M/D/YY');
					} else {
						endDate = moment(self.graphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('M/D/YY');
					}
					this.dateRange = `${startDate} - ${endDate}`;
					chart.xAxis[0].setExtremes(0, this.rightExtreme);
					chart['left'].hide();
					chart['right'].show();
					chart.redraw();
					chart['right'].translate(-10, 0);
					chart['left'].translate(10, 0);
				} else {
					this.leftExtreme = 0;
					this.rightExtreme = this.dataLength;
					let startDate = '';
					let endDate = '';
					if (
						moment(self.graphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
						'Invalid date'
					) {
						startDate = moment(self.graphData['categories'][this.leftExtreme + 1].date, 'YYYY-MM-DD').format('M/D/YY');
					} else {
						startDate = moment(self.graphData['categories'][this.leftExtreme].date, 'YYYY-MM-DD').format('M/D/YY');
					}
					if (
						moment(self.graphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('MM/DD/YY') ===
						'Invalid date'
					) {
						endDate = moment(self.graphData['categories'][this.rightExtreme - 1].date, 'YYYY-MM-DD').format('M/D/YY');
					} else {
						endDate = moment(self.graphData['categories'][this.rightExtreme].date, 'YYYY-MM-DD').format('M/D/YY');
					}
					this.dateRange = `${startDate} - ${endDate}`;
					chart.xAxis[0].setExtremes(0, this.dataLength);
					if (chart['right'] && chart['left']) {
						chart['right'].hide();
						chart['left'].hide();
					}
				}
			}
		);
	}

	updateBorders(series: any): any {
		const first: any = _.first(series);
		if (first.data.length === 1) {
			first.data.unshift({ y: 0, color: '#97bfe6' });
		}
		if (series.length > 1) {
			first['borderRadiusTopLeft'] = '50%';
			first['borderRadiusTopRight'] = '50%';
			const last = _.last(series);
			last['borderRadiusBottomLeft'] = '50%';
			last['borderRadiusBottomRight'] = '50%';
		} else {
			first['borderRadiusTopLeft'] = '50%';
			first['borderRadiusTopRight'] = '50%';
			first['borderRadiusBottomLeft'] = '50%';
			first['borderRadiusBottomRight'] = '50%';
		}
		return series;
	}

	updateTooltipName(): string {
		return this.selectedLegend.displayName;
	}

	selectLegendItem(legendItem: any): void {
		this.selectedMetrics = legendItem.value;
		for (const legendObj of this.filteredLegends) {
			legendObj['selected'] = false;
		}
		const index = this.filteredLegends.findIndex((x) => x.value === this.selectedMetrics);
		this.selectedLegend = this.filteredLegends[index];

		const legendindex = this.legend.findIndex((x) => x.value === this.selectedMetrics);
		this.legend[legendindex].selected = true;

		this.processResponseData(this.responseObject);
	}

	processLegendData(): void {
		for (const legendObj of this.filteredLegends) {
			legendObj['selected'] = false;
		}
		this.selectedMetrics = this.legend[0].value;
		this.legend[0].selected = true;
		this.selectedLegend = this.legend[0];
		this.requestData();
	}

	downloadCSV(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns,
			null,
			this.newTabXLSXRequired ? this.downloadConfiguration.newTabCsvQueryKey : '',
			this.newTabXLSXRequired ? this.downloadConfiguration.newTabCsvFileName : ''
		);
	}
}
